import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';
// Import global data service
import { DataService } from 'src/app/Services/Data/data.service';
import { SELF_SIGN_DISPATCH_LINK } from 'src/environments/constants';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {
  constructor(private dataService: DataService, private router: Router) {}
  self_signer: boolean = false;
  document_id: string;
  sn_token: string;
  url: any;
  client_timestamp: string;
  redirect: boolean = false;
  redirectUrl: string = '';
  error_messages: any = [];
  signedRequestStr: any;
  loading_setting_message: string = 'Loading Settings.';
  loading_redirect_message: string = 'Redirecting back to Salesforce Record.';
  loading_self_signer: string = 'Successfully Sent Document Invite. Redirecting to Self Sign the Document.';
  loading_settings: boolean = true;

  async ngOnInit() {
    this.clearErrors();
    this.loading_settings = true;
    var data;
    var sf_data;
    if (this.getUrlParameter('returned', window.location) === 'true') {
      this.self_signer = false;
      this.signedRequestStr = decodeURIComponent(this.getUrlParameter('sr', window.location));
      var salesforce_session_data = await this.dataService
        .apiGetCall('/api/salesforce_session_data')
        .toPromise();

      this.dataService.maintenanceCheck(salesforce_session_data);

      this.signedRequestStr = salesforce_session_data.signedRequest;
    } else {
      data = this.dataService.getData();
      this.sn_token = this.dataService.getSNToken();
      this.dataService.loadSalesforceData();
      sf_data = this.dataService.getSalesforceData();
      var salesforce_session_data = await this.dataService
        .apiGetCall('/api/salesforce_session_data')
        .toPromise();

      this.dataService.maintenanceCheck(salesforce_session_data);

      this.signedRequestStr = salesforce_session_data.signedRequest;
      this.dataService.setSalesforceContext(sf_data.context);
      this.self_signer = data.self_signer;
      this.document_id = data.document_id;
    }
    if (this.self_signer == true) {
      this.redirect = false;
      var selfSignerEmail = this.dataService.getSelfSignerClientEmail();
      var client = this.dataService.getUrlParamater('client');
      var mobile = this.dataService.getUrlParamater('mobile');
      var urlParamRedirect = this.dataService.getUrlParamater('redirect');

      var uriParams = '';
      var redirectVal;
      if (urlParamRedirect == 'true') {
        redirectVal = true;
      } else {
        redirectVal = false;
      }

      if (client === 'hibu') {
        uriParams =
          '?client=hibu&document_id=' +
          this.document_id +
          '&addcustomaudit=true&redirect=' +
          redirectVal +
          '&self_signer_email=' +
          selfSignerEmail +
          '&access_token=' +
          this.sn_token +
          '&returned=true';
      } else {
        uriParams =
          '?redirect=' +
          redirectVal +
          '&document_id=' +
          this.document_id +
          '&access_token=' +
          this.sn_token +
          '&returned=true';
      }
      var uri = encodeURIComponent(window.location.href + uriParams);
      this.loading_settings = false;
      data = this.dataService.getData();

      if (mobile === 'true') {
        window.location.href = `${SELF_SIGN_DISPATCH_LINK}?route=fieldinvite&skip_mobile_choice=true&document_id=${this.document_id}&access_token=${this.sn_token}&redirect_uri=${uri}&snfiller=snfiller6`;
      } else {
        window.location.href = `${SELF_SIGN_DISPATCH_LINK}?route=fieldinvite&skip_mobile_choice=true&document_id=${this.document_id}&access_token=${this.sn_token}&redirect_uri=${uri}`;
      }
    } else {
      this.loading_settings = true;
      var addcustomaudit;
      var returned = this.getUrlParameter('returned', window.location) === 'true';

      if (returned == true) {
        client = this.getUrlParameter('client', window.location);
        addcustomaudit = this.getUrlParameter('addcustomaudit', window.location);
        this.redirect = this.getUrlParameter('redirect', window.location) === 'true'; // converts string boolean value to boolean object
        this.redirectUrl = this.getUrlParameter(
          'redirectUrl',
          this.dataService.getUrlFromSFContext() || window.location
        );

        if (this.redirect != true) {
          this.loading_settings = false;
        }
      } else {
        try {
          var url = this.dataService.getUrlFromSFContext();
          client = this.getUrlParameter('client', url);
          var option = this.getUrlParameter('option', url);
          addcustomaudit = client === 'hibu' && option !== 'edit_email' ? 'true' : 'false';
          this.redirect = this.getUrlParameter('redirect', url) === 'true';
          this.redirectUrl = this.getUrlParameter('redirectUrl', url);
          if (this.redirect == false) {
            this.loading_settings = false;
          }
        } catch (error) {
          this.updateError(error);
          client = '';
          addcustomaudit = 'false';
          this.loading_settings = false;
          this.redirect = false;
          return;
        }
      }

      if (client === 'hibu' && addcustomaudit === 'true') {
        this.redirect = true;
        var client_timestamp = Math.round(+new Date() / 1000).toString();
        var document_id = this.getUrlParameter('document_id', window.location);
        var sn_token = this.getUrlParameter('access_token', window.location);
        var self_signer_email = this.getUrlParameter('self_signer_email', window.location);

        var body = {
          document_id: document_id,
          client_timestamp: client_timestamp,
          sn_token: sn_token,
          self_signer_email: self_signer_email
        };

        try {
          await this.dataService.apiPostCall('/api/add_custom_audit', JSON.stringify(body)).toPromise();
        } catch (error) {
          this.redirect = false;
          this.loading_settings = false;
          this.updateError('Failed to add custom audit logs to the document. Error: ' + error.error);
        }

        var found_error = false;
        try {
          this.redirectUser();
        } catch {
          found_error = true;
        }
        if (this.error_messages.length == 0 && found_error == true) {
          this.dataService.reinitialize();
        }
      } else {
        if (this.redirect == true) {
          var found_error = false;
          try {
            this.redirectUser();
          } catch {
            found_error = true;
          }
          if (this.error_messages.length == 0 && found_error == true) {
            this.dataService.reinitialize();
          }
        }
      }
    }
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  removeErrorMessage(error_message) {
    for (var i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        this.error_messages.splice(i, 1);
      }
    }
  }
  clearErrors() {
    this.error_messages = [];
  }

  redirectUser() {
    this.loading_settings = false;
    if (this.redirectUrl && this.redirectUrl.length > 3) {
      try {
        var sr = JSON.parse(this.signedRequestStr);
        Sfdc.canvas.client.publish(sr.client, { name: 'namespace.redirect', payload: '' });
      } catch (error) {
        this.redirect = false;
        this.updateError('Something failed with redirecting. Error: ' + error.error);
        throw Error('');
      }
    } else {
      try {
        var sr = JSON.parse(this.signedRequestStr);
        Sfdc.canvas.client.publish(sr.client, { name: 'namespace.redirect_back_to_record', payload: '' });
      } catch (error) {
        this.redirect = false;
        this.updateError('Something failed with redirecting back to record. Error: ' + error.error);
        throw Error('');
      }
    }
  }

  getUrlParameter(name, url) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + name + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    if (results == null) {
      return '';
    } else {
      return results[1];
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    window.location.href = window.location.origin;
  }
  back_to_templates_page() {
    this.dataService.reinitialize();
    let link = ['templates/'];
    this.router.navigate(link);
  }
}
